
<template>
  <div id="wordbank">
    <h4>Select a word</h4>
    <WordbankWord v-for="word in words" :word="word" />
  </div>

</template>

<script>
import Vue from 'vue'
import WordbankWord from './WordbankWord'
import Chapter from '../../resources/chapter'

export default {
  props: ['words'],
  components: {
    WordbankWord,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="sass" scoped>
  h4 {margin-top:0px;}
#wordbank {
  text-align: center;
  /*background: yellow;*/
  height: 82px;
  overflow-y: auto;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}


</style>



// WEBPACK FOOTER //
// Wordbank.vue?1c28d891